define( function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/css/var/cssExpand.js
// module id = 88
// module chunks = 0